export const test_contratto_array = [
    {
        "contratto_id": 1,
        "contratto_codiceContratto": "W639A07",
        "contratto_codiceContratto0": "W",
        "contratto_codiceContratto1": "6",
        "contratto_codiceContratto2": "3",
        "contratto_codiceContratto3": "9",
        "contratto_codiceContratto4": "A",
        "contratto_codiceContratto5": "0",
        "contratto_codiceContratto6": "7",
        "contratto_RagSoc": "SANPELLEGRINO SPA",
        "contratto_indSedeLegale": "LOCALITA' RUSPINO",
        "contratto_provinciaSedeLegale": "BG",
        "contratto_locSedeLegale": "SAN PELLEGRINO TERME",
        "contratto_capSedeLegale": "24016",
        "contratto_pIva": "00753740158",
        "contratto_cPag": "BONIFICO BANCARIO 60 GG D.F.F.M.",
        "contratto_banca": "SANPAOLO BANCO DI NAPOLI - AG. MARIGLIANO 683",
        "contratto_abi": "01010",
        "contratto_cab": "39962",
        "contratto_cc": "100000005259",
        "contratto_cin": "R",
        "contratto_personaDaContattare": "test luca su Unita locale",
        "contratto_indSpedizioneOp": "VIA CASTELVETRO, 17/23",
        "contratto_frazioneOp": "",
        "contratto_id_provincia": 15,
        "contratto_locOp": "Milano",
        "contratto_capOp": "20154",
        "contratto_Sigla": "WW1 SQL",
        "contratto_procedura": "WINWASTE.NET VERSIONE WW1 SQL SERVER + 1 CAL",
        "contratto_dataInstallazione": "2013-01-01",
        "contratto_dataAttivazione": "01/01/2013",
        "contratto_dataScadenza": "31/12/2013",
        "contratto_codSede": 4,
        "contratto_Licenza": "1600,00",
        "contratto_Assistenza": "816,00",
        "contratto_quantita": 1,
        "contratto_rate": "GENNAIO / LUGLIO",
        "contratto_provinciaOp": "MI",
        "contratto_prezzoTotale": "12.499,00",
        "contratto_desFull": "WINWASTE.NET VERSIONE WW1 SQL SERVER + 1 CAL",
        "contratto_importoInLettereFull": "ottocentosedici/00",
        "contratto_quantitaFull": 1,
        "contratto_assistenzaFull": "816,00"
    },
    {
        "contratto_id": 172,
        "contratto_CodContatto": 1,
        "contratto_CodSede": 4,
        "contratto_CodProcedura": 101,
        "contratto_CodModulo": 200,
        "contratto_id_master_procedura": 171,
        "contratto_procedura_attiva": 1,
        "contratto_dataAttivazione": "2013-01-01",
        "contratto_dataInstallazione": null,
        "contratto_dataScadenza": "2013-12-31",
        "contratto_note": null,
        "contratto_quantita": 11,
        "contratto_keycode": "000001W639A0701252613001",
        "contratto_Licenza": "180,00",
        "contratto_Assistenza": "153,00",
        "contratto_escludiContratto": 0,
        "contratto_fonte": 0,
        "contratto_ApplicaIstat": 0,
        "contratto_Motivazione": null,
        "contratto_nota": "",
        "contratto_RateoIniziale": 0,
        "contratto_des": "CAL DI ACCESSO LOCALE PROCEDURA WINWASTE.NET",
        "contratto_Sigla": "CALLOC.",
        "contratto_prezzoTotale": "12.499,00",
        "contratto_desFull": "CAL DI ACCESSO LOCALE PROCEDURA WINWASTE.NET",
        "contratto_importoInLettereFull": "centocinquantatré/00",
        "contratto_quantitaFull": 11,
        "contratto_assistenzaFull": "153,00"
    },
    {
        "contratto_id": 14997,
        "contratto_CodContatto": 1,
        "contratto_CodSede": 4,
        "contratto_CodProcedura": 101,
        "contratto_CodModulo": 19,
        "contratto_id_master_procedura": 171,
        "contratto_procedura_attiva": 1,
        "contratto_dataAttivazione": "2025-01-01",
        "contratto_dataInstallazione": "2025-07-30",
        "contratto_dataScadenza": "2025-12-31",
        "contratto_note": null,
        "contratto_quantita": 1,
        "contratto_keycode": null,
        "contratto_Licenza": "0,00",
        "contratto_Assistenza": "0,00",
        "contratto_escludiContratto": 0,
        "contratto_fonte": 0,
        "contratto_ApplicaIstat": 0,
        "contratto_Motivazione": null,
        "contratto_nota": null,
        "contratto_RateoIniziale": 0,
        "contratto_des": "MODULO COMUNICAZIONE IVA PERIODICA",
        "contratto_Sigla": "MODULO IVA",
        "contratto_prezzoTotale": "21.499,00",
        "contratto_desFull": "MODULO COMUNICAZIONE IVA PERIODICA",
        "contratto_importoInLettereFull": "zero/00",
        "contratto_quantitaFull": 1,
        "contratto_assistenzaFull": "0,00"
    }
]